import ProofreadingOrderRepository from '@/repositories/ProofreadingOrderRepository';
import StudentRepository from '@/repositories/StudentRepository';
import FinanceRepository from '@/repositories/FinanceRepository';
import OwnSourcesCheckerRepository from '@/repositories/OwnSourcesCheckerRepository';
import SupportRepository from '@/repositories/SupportRepository';
import UserRepository from '@/repositories/UserRepository';
import InvoiceRepository from '@/repositories/InvoiceRepository';
import PlagiarismOrderRepository from '@/repositories/PlagiarismOrderRepository';
import DiscountRepository from '@/repositories/DiscountRepository';
import BasketRepository from '@/repositories/BasketRepository';
import CitationGeneratorRepository from '~/repositories/CitationGeneratorRepository';
import DashboardInitialFetchRepository from '~/repositories/DashboardInitialFetchRepository';
import TechademiaCheckersRepository from '~/repositories/TechademiaCheckersRepository';
import EssayEditingRepository from '~/repositories/EssayEditingRepository';
import UserProfileRepository from '~/repositories/UserProfileRepository';
import ExpertReviewRepository from '~/repositories/ExpertReviewRepository';
import GrammarCheckRepository from '~/repositories/GrammarCheckRepository';
import FileRepository from '~/repositories/FileRepository';
import aiProofreaderOrderRepository from '~/repositories/AIProofreaderOrderRepository';
import CitationCheckerRepository from '~/repositories/CitationCheckerRepository';
import GenderCheckerRepository from '~/repositories/GenderCheckerRepository';
import ConsistencyCheckerRepository from '~/repositories/ConsistencyCheckerRepository';
import CheckoutRepository from '~/repositories/CheckoutRepository';
import ParaphraserRepository from '~/repositories/ParaphraserRepository';

const repositories = {
    ProofreadingOrderRepository,
    PlagiarismOrderRepository,
    aiProofreaderOrderRepository,
    StudentRepository,
    FinanceRepository,
    OwnSourcesCheckerRepository,
    SupportRepository,
    UserRepository,
    InvoiceRepository,
    DiscountRepository,
    BasketRepository,
    CitationGeneratorRepository,
    DashboardInitialFetchRepository,
    TechademiaCheckersRepository,
    EssayEditingRepository,
    UserProfileRepository,
    ExpertReviewRepository,
    GrammarCheckRepository,
    FileRepository,
    CitationCheckerRepository,
    GenderCheckerRepository,
    ConsistencyCheckerRepository,
    CheckoutRepository,
    ParaphraserRepository,
};

const lcFirst = (string) => {
    return string.charAt(0).toLowerCase() + string.slice(1);
};

export default (ctx, inject) => {
    Object.keys(repositories).forEach((key) => {
        inject(lcFirst(key), repositories[key](ctx.$axios)(ctx));
    });
};
